// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

var default_style = {
  height: "67px",
  width: "354px",
  borderRadius: "60px"
};

var default_cls = "text-size-h1 max-w-full font-heading ";

function Button$Outline(Props) {
  var label = Props.label;
  var disabledOpt = Props.disabled;
  var onClick = Props.onClick;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var cls = disabled ? "bg-white text-gray border-2 border-black" : "bg-white text-red border-red border-2";
  var tmp = {
    className: default_cls + cls,
    style: default_style,
    disabled: disabled
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement("button", tmp, label);
}

var Outline = {
  make: Button$Outline
};

function Button(Props) {
  var label = Props.label;
  var disabledOpt = Props.disabled;
  var onClick = Props.onClick;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var cls = disabled ? "bg-disabled text-white" : "bg-red text-white filter drop-shadow-primary";
  var tmp = {
    className: default_cls + cls,
    style: default_style,
    disabled: disabled
  };
  if (onClick !== undefined) {
    tmp.onClick = Caml_option.valFromOption(onClick);
  }
  return React.createElement("button", tmp, label);
}

var make = Button;

export {
  default_style ,
  default_cls ,
  Outline ,
  make ,
  
}
/* react Not a pure module */
